export const heading = 'An expert by your side throughout retirement.';
export const body =
  'Your dedicated advisor will help you grow your savings, spend smarter, and navigate key decisions.';
